import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IObjectsControllable, ILinkedObjectGroupSpecifiable } from "../../../../documaker/domain/format/objects";

export interface IGroupAlertAllowBehaviorPropertyEditable {
  groupAlertAllowBehavior(): IPropertyEditable<IObjectsControllable<ILinkedObjectGroupSpecifiable>>;
}

export function instanceOfIGroupAlertAllowBehaviorPropertyEditable(instance: any): instance is IGroupAlertAllowBehaviorPropertyEditable {
  return instance
      && instance.groupAlertAllowBehavior
      && instanceOfIPropertyEditable<IObjectsControllable<ILinkedObjectGroupSpecifiable>>(instance.groupAlertAllowBehavior());
}
